import { render, staticRenderFns } from "./TributeRenderSuper.vue?vue&type=template&id=52f17cb0&scoped=true"
import script from "./TributeRenderSuper.vue?vue&type=script&lang=js"
export * from "./TributeRenderSuper.vue?vue&type=script&lang=js"
import style0 from "./TributeRenderSuper.vue?vue&type=style&index=0&id=52f17cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f17cb0",
  null
  
)

export default component.exports